import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Message from 'component/Message';
import { Link } from 'dcme-style/affordance';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`When called on a Parcel with an indexed value, such as an array, this method can accept an `}<inlineCode parentName="p">{`index`}</inlineCode>{` or a `}<inlineCode parentName="p">{`key`}</inlineCode>{`.`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`index`}</inlineCode>{` (number) is used to get a value based off its position. It can also be negative, indicating an offset from the end of the sequence.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`key`}</inlineCode>{` (string) is used to get a specific value by its unique key within the Parcel.`}</li>
    </ul>
    <Message mdxType="Message">
    Dataparcels automatically gives unique keys to all elements of an indexed parcel. See <Link to="/parcel-keys" mdxType="Link">parcel keys</Link> for more info.
    </Message>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      